import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import s from './StaticInfoBlock.css';
import l from '../../Skeleton/Skeleton.css';

// Components
import HomeKindofTrip from '../HomeKindofTrip/HomeKindofTrip';

// Skeleton Loader
import Shimmer from '../../Skeleton/Shimmer';
import HomeKindofTripSkeleton from '../../Skeleton/HomeKindofTripSkeleton';
import { dynamicStaticInfoValue } from '../../../helpers/GetDynamicItemName/dynamicHomeValue';

// GraphQL
import { getStaticInfo } from '../../../lib/graphql';
import { withQuery } from '../../../hoc/withGraphql';



const StaticInfoBlock = ({ getStaticInfoData: { loading, getStaticInfo }, intl }) => {
  const staticInfoCollection = useMemo(() => {
    return getStaticInfo?.reduce((acc, { name, value, dynamicStaticInfoBlock }) => {
      acc[name] = dynamicStaticInfoValue(name, value, dynamicStaticInfoBlock, intl?.locale);
      return acc;
    }, {}) || {};
  }, [getStaticInfo, intl?.locale]);

  return (
    <div className="hidden-xs">
      {loading ? (
        <div className={s.container}>
          <div className={cx(l.popularSkeletonTwoTitle, 'bgBlackTwo')}>
            <Shimmer />
          </div>
          <HomeKindofTripSkeleton />
        </div>
      ) : (
        <HomeKindofTrip staticInfo={staticInfoCollection} />
      )}
    </div>
  );
};

StaticInfoBlock.propTypes = {
  getStaticInfoData: PropTypes.shape({
    loading: PropTypes.bool,
    getStaticInfo: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
        dynamicStaticInfoBlock: PropTypes.arrayOf(
          PropTypes.shape({
            language: PropTypes.string,
            value: PropTypes.string
          })
        )
      })
    ),
  }),
};

StaticInfoBlock.defaultProps = {
  getStaticInfoData: {
    loading: true,
    getStaticInfo: [],
  },
};

export default compose(
  injectIntl,
  withStyles(s, l),
  withQuery(getStaticInfo, {
    name: 'getStaticInfoData',
    options: {
      ssr: false,
      fetchPolicy: 'network-only',
    },
  })
)(StaticInfoBlock);
